import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPlanTypesInputDto, PlanTypeCreateDto, PlanTypeDto, PlanTypeExcelDownloadDto, PlanTypeUpdateDto } from '../dtos/plan-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PlanTypeService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: PlanTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto>({
      method: 'POST',
      url: '/api/controlling/planTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/planTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/planTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto>({
      method: 'GET',
      url: `/api/controlling/planTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/planTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPlanTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlanTypeDto>>({
      method: 'GET',
      url: '/api/controlling/planTypes',
      params: { name: input.name, code: input.code, description: input.description, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PlanTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/planTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, description: input.description, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto[]>({
      method: 'GET',
      url: '/api/controlling/planTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PlanTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto>({
      method: 'PUT',
      url: `/api/controlling/planTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}